import React, { Component } from 'react';
import FormatDate from '../../../utility/FormatDate';

class TabelaAlunos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.listaAlunos
        }
        this.sortColumn = this.sortColumn.bind(this)
    }

    getValorEngajamentoAluno(engajamento) {
        if (engajamento && engajamento.length) {
            const e = engajamento[0]
            return Math.trunc(((e.simuladosFinalizados + e.estudosConcluidos) / (e.totalSimulados + e.estudosAlocados) * 100)) + "%"
        }
        return '-'
    }

    exportCSV(filename) {
        var csv = [];
        var rows = document.querySelectorAll("table#tbl_alunos tr");

        for (var i = 0; i < rows.length; i++) {
            var row = [], cols = rows[i].querySelectorAll("td, th");

            for (var j = 0; j < cols.length; j++)
                row.push(cols[j].innerText);

            csv.push(row.join(";"));
        }

        var d = new Date();
        // Download CSV FILE
        var csvFile = new Blob(["\ufeff", csv.join("\n")], {type: "text/csv"});
        var downloadLink = document.createElement("a");
        downloadLink.download = "lista-alunos_"+filename+"_"+FormatDate.formatISODateTime(d)+".csv";
        downloadLink.href = window.URL.createObjectURL(csvFile);
        downloadLink.style.display = "none";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.remove();
    }

    sortColumn(ev) {
        let th = ev.target;
        if(th.tagName!=="TH") {
            th = ev.target.closest("th");
        }
        let sort = th.querySelector("i.sort");
        let tr = th.closest("tr");
        let orderUp = true;

        let sortNumber = false;
        let sortDate = false;


        // change sort icon
        if(sort.classList.contains('fa-sort')) {
            var sorts = tr.querySelectorAll("i.sort");
            for (var i = 0; i < sorts.length; i++) {
              if(!sorts[i].classList.contains('fa-sort')) {
                  sorts[i].classList.remove('fa-sort-up', 'fa-sort-down');
                  sorts[i].classList.add('fa-sort')
              }
            }
            sort.classList.remove('fa-sort');
            sort.classList.add('fa-sort-up')
        }
        else if(sort.classList.contains('fa-sort-up')) {
            sort.classList.remove('fa-sort-up');
            sort.classList.add('fa-sort-down')
            orderUp = false;
        }
        else if(sort.classList.contains('fa-sort-down')) {
            sort.classList.remove('fa-sort-down');
            sort.classList.add('fa-sort-up')
        }

        if(sort.classList.contains('sort-date')) {
            sortDate = true;
        }
        if(sort.classList.contains('sort-number')) {
            sortNumber = true;
        }

        const sortBy = sort.getAttribute("data-sort");
        const data = this.state.data;

        data.sort((a,b) => {
            // ordenação ascendente
            if(orderUp) {
                if(sortNumber) return (!a[sortBy] || a[sortBy] === '-' ? -1 : a[sortBy]) - (!b[sortBy] || b[sortBy] === '-' ? -1 : b[sortBy]);
                if(sortDate) return (!a[sortBy] || a[sortBy] === '-' ? new Date() : new Date(a[sortBy])) - (!b[sortBy] || b[sortBy] === '-' ? new Date() : new Date(b[sortBy]));
                // sortText
                return a[sortBy].localeCompare(b[sortBy]);
            }
            // ordernação descendente
            if(sortNumber) return (!b[sortBy] || b[sortBy] === '-' ? -1 : b[sortBy]) - (!a[sortBy] || a[sortBy] === '-' ? -1 : a[sortBy]);
            if(sortDate) return (!b[sortBy] || b[sortBy] === '-' ? new Date() : new Date(b[sortBy])) - (!a[sortBy] || a[sortBy] === '-' ? new Date() : new Date(a[sortBy]));
            // sortText
            return b[sortBy].localeCompare(a[sortBy]);
        });

        this.setState({data});
    }

    render() {
        return (<div>
            <button className="edb-hide-small edb-hide-medium edb-button edb-right edb-padding" title="Exportar tabela em formato CSV" onClick={()=>this.exportCSV(this.props.fileName)}><i className="edb-xlarge fas fa-file-download"></i></button>
            <table id="tbl_alunos" className="edb-table edb-round-large edb-bordered adap-white edb-striped ">
                <thead className="edb-hide-small">
                    <tr>
                        <th className="edb-padding-small-left edb-padding-small-right edb-no-break-lines" onClick={this.sortColumn}>Aluno <i data-sort="txScreenName" className="sort fas fa-sort-up"></i></th>
                        <th className="edb-padding-small-left edb-padding-small-right edb-no-break-lines" onClick={this.sortColumn}>Turma <i data-sort="txClass" className="sort fas fa-sort"></i></th>
                        <th className="edb-padding-small-left edb-padding-small-right edb-no-break-lines" onClick={this.sortColumn}>Situação <i data-sort="txExamTakenStatus" className="sort fas fa-sort"></i></th>
                        <th className="edb-padding-small-left edb-padding-small-right edb-no-break-lines" onClick={this.sortColumn}>Realização <i data-sort="dtStart" className="sort sort-date fas fa-sort"></i></th>
                        <th className="edb-padding-small-left edb-padding-small-right edb-no-break-lines" onClick={this.sortColumn}>Nota TRI <i data-sort="nuScoreTRI" className="sort sort-number fas fa-sort"></i></th>
                        <th className="edb-padding-small-left edb-padding-small-right edb-no-break-lines" onClick={this.sortColumn}>Pontos <i data-sort="nuPoints" className="sort sort-number fas fa-sort"></i></th>
                        {/* <th className="">Ações</th> */}
                        <th className="edb-padding-small-left edb-padding-small-right edb-no-break-lines" onClick={this.sortColumn}>Estudos <i data-sort="pcStudies" className="sort sort-number fas fa-sort"></i></th>
                    </tr>
                </thead>
                <tbody>
                    {(this.state.data || []).map((item, index) => (<tr key={'realizacoes_' + index}>
                        <td className="edb-padding-small-left edb-padding-small-right edb-block-mobile">
                            <div className="edb-hide-medium edb-hide-large edb-margin-small-bottom edb-left edb-margin-small-right">
                                <span className="edb-text-bold"> Aluno</span>
                            </div>
                            <div className="edb-left-align">
                                {item.txScreenName}
                            </div>
                        </td>
                        <td className="edb-padding-small-left edb-padding-small-right edb-block-mobile">
                            <div className="edb-hide-medium edb-hide-large edb-margin-small-bottom edb-left edb-margin-small-right">
                                <span className="edb-text-bold"> Turma</span>
                            </div>
                            <div className="edb-left-align">
                                {item.txClass}
                            </div>
                        </td>
                        <td className="edb-padding-small-left edb-padding-small-right edb-block-mobile">
                            <div className="edb-hide-medium edb-hide-large edb-margin-small-bottom edb-left edb-margin-small-right">
                                <span className="edb-text-bold"> Situação</span>
                            </div>
                            <div className="edb-left-align">
                                {item.txExamTakenStatus}
                            </div>
                        </td>
                        <td className="edb-padding-small-left edb-padding-small-right edb-block-mobile">
                            <div className="edb-hide-medium edb-hide-large edb-margin-small-bottom edb-left edb-margin-small-right">
                                <span className="edb-text-bold"> Data de realização</span>
                            </div>
                            <div className="edb-left-align">
                                {FormatDate.formatDateTime(item.dtStart)}
                            </div>
                        </td>
                        <td className="edb-padding-small-left edb-padding-small-right edb-block-mobile">
                            <div className="edb-hide-medium edb-hide-large edb-margin-small-bottom edb-left edb-margin-small-right">
                                <span className="edb-text-bold"> Nota TRI</span>
                            </div>
                            <div className="edb-left-align">
                                {item.nuScoreTRI? parseFloat(Math.round(item.nuScoreTRI * 100) / 100).toFixed(2).replace('.', ',') : '-'}
                            </div>
                        </td>
                        <td className="edb-padding-small-left edb-padding-small-right edb-block-mobile">
                            <div className="edb-hide-medium edb-hide-large edb-margin-small-bottom edb-left edb-margin-small-right">
                                <span className="edb-text-bold"> Pontos</span>
                            </div>
                            <div className="edb-left-align">
                                {item.nuPoints? item.nuPoints : '-'}
                            </div>
                        </td>
                        {/* <td className="" >
                            <span className="edb-btn-link adap-text-green edb-text-bold" onClick={_ => this.onDesempenhoAlunoSelecionado(item.idUser)}>Desempenho</span>
                            <span className="edb-btn-link adap-text-green edb-text-bold" onClick={_ => this.onGabaritoAlunoSelecionado(item.idUser, item.idExam)}>Gabarito</span>
                            <span className="edb-btn-link adap-text-green edb-text-bold" onClick={_ => this.onDetalhesAlunoSelecionado(item.idUser, item.idExam)}>Detalhes</span>
                        </td> */}
                        <td className="edb-padding-small-left edb-padding-small-right edb-block-mobile">
                            <div className="edb-hide-medium edb-hide-large edb-margin-small-bottom edb-left edb-margin-small-right">
                                <span className="edb-text-bold"> Estudos realizados</span>
                            </div>
                            <div className="edb-left-align">
                            {item.pcStudies ? parseFloat(Math.round(item.pcStudies * 100) / 100).toFixed(2).replace('.', ',')+"%" : '-'}
                            </div>
                        </td>
                    </tr>)
                    )}
                </tbody>
            </table>
            </div>
         );
    }
}

export default TabelaAlunos;